module.exports = __webpack_public_path__ + "img/1547870975.3dd75ac5.jpg";